module.exports = __webpack_public_path__ + "img/32.d980999a.jpg";